import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'

import { Row, Col, Button } from 'react-bootstrap'
import { i18nTranslate } from 'src/utils'
import { IoIosOptions } from 'react-icons/io'
import { AccordionBlock } from 'src/views/components'
import { handleFilterCbk } from 'src/deps'
import isMerchPLP from 'config/appConfig'
import { application } from 'src/utils'
import { AccordionDragAndDrop } from './AccordionDragAndDrop'
import { SelectedFilters } from '../SelectedFilter'
import { ListView } from '../ListView'
import './styles.scss'

@observer
class AccordionFilter extends React.Component {
  static defaultProps = {
    isMultiFilterSelection: true,
  }
  @observable filterList = []
  @observable isFilterClose = false
  @observable selectedFilter = this.props?.filterProps
    ? JSON.parse(this.props?.filterProps || '{}').filters
    : []

  constructor(props) {
    super(props)
    this.filterList = props.facetFilter
  }

  componentDidUpdate = prevProps => {
    const { facetFilter } = this.props
    this.filterList = facetFilter
    const isDifferentCategory =
      prevProps.location.pathname !== this.props.location.pathname
    // const
    if (isDifferentCategory) {
      this.isFilterClose = false
      this.selectedFilter = []
    }
    try {
      if (prevProps.filterProps !== this.props.filterProps) {
        if (!this.props.filterProps) {
          this.selectedFilter = []
        } else {
          this.selectedFilter = this.props.filterProps
            ? JSON.parse(this.props.filterProps).filters
            : []
        }
      }
    } catch (e) {
      console.error('JSON.parse may be an error >>> ', e)
    }
  }

  renderTitle = () => {
    const isTemplate6 = this.props?.Template6 || fasle

    return (
      <span className="text-uppercase filter-title">
        {isTemplate6
          ? this.isFilterClose
            ? i18nTranslate('template4.hideFilter', 'Hide Filters')
            : i18nTranslate('template4.showFilter', 'Show Filters')
          : i18nTranslate('template4.filter', 'Filters')}
      </span>
    )
  }

  handleClick = (name, value) => {
    if (this.props.isMultiFilterSelection) {
      this.selectedFilter = handleFilterCbk({
        props: { ...this.props },
        nameValue: { name, value },
        makeApi: false,
        selectedFilter: this.selectedFilter,
      })
    } else {
      handleFilterCbk({
        props: { ...this.props },
        nameValue: { name, value },
        makeApi: true,
      })
    }
  }

  handleApplyFilter = () => {
    if (!isMerchPLP) {
      if (this.selectedFilter.length) {
        this.props.handleFilter(this.selectedFilter)
      }
    }
    this.isFilterClose = false
  }
  handleClearFilter = () => {
    if (this.props.filterProps) {
      this.props.handleFilter()
    }
    this.selectedFilter = []
    this.isFilterClose = false
  }
  handleAccordionClick = props => {
    this.isFilterClose = props.isOpen && true
    if (!this.props.filterProps) {
      this.selectedFilter = []
    }
  }
  getFilterCount = () => {
    let count = 0
    this.selectedFilter &&
      this.selectedFilter.forEach(filter => {
        const value = filter.value.split(',')
        count = count + value.length
      })
    return count
  }

  isFilterChecked = (name, keyName) => {
    const filterKey = this.selectedFilter.find(
      filter => filter.field === keyName
    )
    const filters = filterKey && filterKey.value.trim().split(',')
    if (filterKey && filters.includes(name)) {
      return true
    }
    return false
  }

  listView = item => {
    return (
      <ListView
        item={item}
        className="check-box-wrap mb-2 text-break"
        handleClick={this.handleClick}
        isFilterChecked={this.isFilterChecked}
      />
    )
  }

  handleVisibilityToggle = props => {
    this.filterList.forEach((item, index) => {
      const name = item.name !== null ? item.name.toLowerCase() : item.name
      if (props.selectedFacet.toLowerCase().includes(name)) {
        this.filterList[index].isVisible = props.isOpen
      }
    })
  }

  renderActiveFilter = item => {
    if (item && item.isVisible !== '' && item.isVisible !== undefined) {
      return item.isVisible
    } else {
      return false
    }
  }
  renderMobileFilterHeader = (item, index) => {
    const isActive = this.renderActiveFilter(item)

    const classes = index === 0 ? 'border-top mt-2' : ''
    const currentFilter = this.selectedFilter.find(filter => {
      return filter.field === item.key
    })
    const count = currentFilter && currentFilter.value.split(',').length
    const title = () => {
      if (application.isMobile) {
        return (
          <React.Fragment key={index}>
            {count && (
              <Row noGutters className="w-100 text-capitalize filters-count">
                <span className="pr-1">{count}</span>
                {i18nTranslate(
                  'filter.filterSelectedTitle',
                  'filters selected',
                  {
                    nameSpace: 'ssr-resource',
                  }
                )}
              </Row>
            )}
          </React.Fragment>
        )
      }
      // return item.name
    }
    return (
      <Row noGutters className="mb-3 flex-column flex-md-row">
        <AccordionBlock
          key={`filter-accordion_${index}`}
          className={`filter-facet border-bottom border-light-grey py-3 ${classes}`}
          dataTestId="qa-plp-filter"
          title={item.name}
          prefillData={title()}
          additionalClass={'flex-column'}
          textClass={'mobile-filter-category'}
          // onClick={this.handleAccordionOpenClick}
          isActive={isActive}
          isMerchPLP={isMerchPLP}
          onClick={this.handleVisibilityToggle}
          index={index}>
          <ol className="facet-list p-0 m-0 pt-2">
            <fieldset>
              <legend>{item.name}</legend>
              {this.listView(item)}
            </fieldset>
          </ol>
        </AccordionBlock>
      </Row>
    )
  }

  renderDesktopFilter = filter => {
    const Template6 = this.props?.Template6 || false

    return (
      <>
        {Template6 && (
          <Col lg={2} md={3} sm={12} key={filter.key}>
            <div
              className={`text-uppercase mb-3 ${
                Template6 ? 'ml-3' : ''
              } filter-type-title`}
              data-testid="qa-filter-name">
              {filter.name}
            </div>
            {this.listView(filter)}
          </Col>
        )}

        {!Template6 && (
          <Col lg={3} md={4} sm={12} xs={12} key={filter.key}>
            <div
              className={`text-uppercase mb-3 filter-type-title`}
              data-testid="qa-filter-name">
              {filter.name}
            </div>
            {this.listView(filter)}
          </Col>
        )}
      </>
    )
  }
  renderIcon = () => {
    return (
      <IoIosOptions
        aria-label={i18nTranslate(
          'icons.downwardarrow',
          'downward arrow icon',
          {
            nameSpace: 'ssr-resource',
          }
        )}
      />
    )
  }

  render() {
    const count = this.getFilterCount()
    const Template6 = this.props?.Template6 || fasle

    const { isMultiFilterSelection } = this.props
    return (
      <>
        <AccordionBlock
          isOutsideAccordion={true}
          title={this.renderTitle()}
          textClass={'pr-2 py-2'}
          dataTestId="qa-filter-button"
          className={'mb-0 filter-accordion'}
          {...(Template6 && { renderIcon: this.renderIcon })}
          onClick={this.handleAccordionClick}
          isActive={isMerchPLP ? true : !this.isFilterClose ? false : ''}>
          {application.isMobile ? (
            this.filterList.map(this.renderMobileFilterHeader)
          ) : (
            <AccordionDragAndDrop
              cols={Template6 ? 6 : 4}
              filterList={this.filterList}
              renderFilter={this.listView}
              renderDesktopFilter={this.renderDesktopFilter}
              wrapper={children => (
                <Row noGutters className="mb-3 flex-column flex-md-row">
                  {children}
                </Row>
              )}
            />
          )}
          {isMultiFilterSelection && (
            <Row noGutters className="mb-3 pb-5 button-wrapper border-bottom">
              <Col
                xs={7}
                md={'auto'}
                className="p-0 d-flex justify-content-left">
                <Button
                  onClick={this.handleApplyFilter}
                  variant="outline-dark"
                  className="text-uppercase rounded-0 filter-reset-btns filter-border"
                  data-testid="qa-apply-filters">
                  {i18nTranslate('filter.applyFilterText', 'Apply Filters', {
                    nameSpace: 'ssr-resource',
                  })}
                </Button>
              </Col>
              <Col
                xs={5}
                md={'auto'}
                className="p-0 d-flex justify-content-left ml-md-4">
                <Button
                  onClick={this.handleClearFilter}
                  variant="outline-transparent"
                  className="text-uppercase filter-reset-btns"
                  data-testid="qa-filter-clearall">
                  {i18nTranslate('filter.clearFilterText', 'Clear All', {
                    nameSpace: 'ssr-resource',
                  })}
                </Button>
              </Col>
            </Row>
          )}
        </AccordionBlock>
        {application.isMobile && !this.isFilterClose && count > 0 ? (
          <Row noGutters className="w-100 text-capitalize mb-3 filters-count">
            <span className="pr-1">{count}</span>
            {i18nTranslate('filter.filterSelectedTitle', 'filters selected', {
              nameSpace: 'ssr-resource',
            })}
          </Row>
        ) : (
          <React.Fragment />
        )}
        {!application.isMobile && (
          <SelectedFilters
            {...this.props}
            selectedFilter={this.selectedFilter}
          />
        )}
      </>
    )
  }
}

export { AccordionFilter }
export default AccordionFilter
